import { render, staticRenderFns } from "./Logros.vue?vue&type=template&id=daa847b4&scoped=true"
import script from "./Logros.vue?vue&type=script&lang=js"
export * from "./Logros.vue?vue&type=script&lang=js"
import style0 from "./Logros.vue?vue&type=style&index=0&id=daa847b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa847b4",
  null
  
)

export default component.exports